<div class="va-filter-chip" mat-ripple (click)="emitClickEvent($event)">
  <mat-icon class="icon" *ngIf="!!icon">{{ icon }}</mat-icon>
  <span class="title">{{ title.key | translate }}{{ text ? ':' : '' }}</span>
  <span class="text" *ngIf="!!text">{{ text.key | translate }}</span>
  <button
    mat-icon-button
    *ngIf="!!canDisable"
    (click)="emitDeleteEvent($event)"
  >
    <mat-icon>cancel</mat-icon>
  </button>
  <button mat-icon-button *ngIf="!canDisable">
    <mat-icon>edit</mat-icon>
  </button>
</div>
